import { useEffect, useState, useCallback } from 'react';
import { fetchUserVideos, type VideoRow } from '@/lib/videosRepo';
import { supabase } from '@/integrations/supabase/client';

export function useUserVideos(pageSize = 20) {
  const [rows, setRows] = useState<VideoRow[]>([]);
  const [count, setCount] = useState<number | null>(null);
  const [table, setTable] = useState<string | null>(null);
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  console.log('[VID] init useUserVideos hook');

  const loadPage = useCallback(async (p: number) => {
    console.log('[VID] loadPage', { page: p, pageSize });
    setLoading(true);
    setErr(null);
    
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) { 
        setErr('Not signed in'); 
        setLoading(false); 
        return; 
      }

      const from = p * pageSize;
      const to = from + pageSize - 1;
      const res = await fetchUserVideos(user.id, from, to);
      
      setTable(res.table);
      if (p === 0) {
        setRows(res.data);
      } else {
        setRows(prev => [...prev, ...res.data]);
      }
      setCount(res.count);
      
      console.log('[VID] render', { count: res.count, rowsLength: res.data.length, table: res.table });
    } catch (error) {
      console.error('[VID] loadPage:error', error);
      setErr(error instanceof Error ? error.message : 'Unknown error');
    } finally {
      setLoading(false);
    }
  }, [pageSize]);

  useEffect(() => { 
    loadPage(0); 
  }, [loadPage]);

  const loadMore = useCallback(() => {
    const nextPage = page + 1;
    loadPage(nextPage).then(() => setPage(nextPage));
  }, [loadPage, page]);

  return { 
    rows, 
    count, 
    table, 
    loading, 
    err, 
    loadMore, 
    hasMore: count != null && rows.length < count 
  };
}